import '@pique/env/constant';

import { ResizeObserver } from '@juggle/resize-observer';
import { setupGlobal } from '@pique/env/global';

setupGlobal();

window.ResizeObserver = ResizeObserver;

// Set the data-tauri attribute on the body element if we're in Tauri
if (environment.isTauri) {
  document.body.dataset['tauri'] = 'true';
}
